/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useCallback, useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { OTP_LEN } from "../../contants";
import Member from "../../services/api/member";
import { createArrayByLen, debounce } from "../../utils/helper";
import Button from "../common/Button";
import Modal from "../common/Modal/Modal";
import AutoCompleteDropdown from "../common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import OTPInput from "../common/new/OTPInput/OTPInput";
import Typography from "../common/new/Typography/Typography";
import styles from "./GohonzonHandoverModal.styles";

const MAX_RESULT = 5;

const getMemberOptions = (members) =>
  members.length
    ? members.map((member) => ({
        displayName: `${member.fullName} - ${member.mobileNumber}`,
        value: member.memberId,
      }))
    : [];

function GohonzonHandoverModal({ open, onClose, handleSubmit, title }) {
  const [options, setOptions] = useState([]);
  const [selectedMemberId, setSelecteMemberId] = useState("");
  const [loading, setLoading] = useState(false);

  const onSearchMember = async (search) => {
    const abortSearch = options?.find((m) => m.displayName === search);

    if (abortSearch || !search) return;

    try {
      const formattedQuery = {
        memberId: Number(search),
      };
      const params = {
        pageSize: MAX_RESULT,
      };
      setLoading(true);
      const { data } = await Member.search(formattedQuery, params, false);

      setOptions(getMemberOptions(data.content));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e, selectedMemberId);
  };

  const handleInputChange = useCallback(debounce(onSearchMember), [
    selectedMemberId,
    options,
  ]);

  useEffect(() => {
    return () => setOptions([]);
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <Box>
          <Typography variant="title2" color="#8c8c8c">
            {title}
          </Typography>
          <Box mt={7}>
            {" "}
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.displayName}
              label="Search Member ID"
              name="searchMember"
              options={options}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setSelecteMemberId("");
                  setOptions([]);
                } else {
                  setSelecteMemberId(selectedValue.value);
                }
              }}
              onInputChange={handleInputChange}
              value={selectedMemberId}
              loading={loading}
              filterSelectedOptions={false}
              filterOptions={(x) => x}
            />
          </Box>
          <Box my={4}>
            <Typography variant="small" color="#8c8c8c">
              {`OTP Sent on Member's Registered Number`}
            </Typography>
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {createArrayByLen(OTP_LEN).map((_, index) => (
              <OTPInput id={index + 1} />
            ))}
          </Box>
          <Box my={4} textAlign="right">
            <Typography variant="small" color="#8c8c8c">
              Send OTP Again
            </Typography>
          </Box>
        </Box>
        <Box display="flex" gap={2} mt={8}>
          <Button type="submit" style={styles.submitButton} label="SUBMIT" />
          <Button
            style={{ width: "100%", height: "40px" }}
            onClick={onClose}
            variant="outlined"
            label="CANCEL"
          />
        </Box>
      </form>
    </Modal>
  );
}

export default GohonzonHandoverModal;
